import { createApi } from '@reduxjs/toolkit/query/react';

import { IApiResponse } from '../types/IApiResponse';
import { IItem } from '../types/IItem';
import { IServiceItem } from '../types/IServiceItem';
import baseQueryCheckAccessToken from './baseQueryCheckAccessToken';

type TServiceListResponse = IApiResponse<IServiceItem[]>;

export const ticketAPI = createApi({
  reducerPath: 'ticketAPI',
  baseQuery: baseQueryCheckAccessToken,
  tagTypes: ['Ticket', 'Warehouse', 'Services'],
  endpoints: (build) => ({
    getAllItemsTickets: build.query<IItem[], any>({
      query: () => ({
        url: `/tickets/allTickets`,
      }),
      providesTags: () => ['Ticket'],
    }),
    getTicketsByPoint: build.query<IItem[], any>({
      query: ({ point_id }) => ({
        url: `/tickets/allTicketsByPoint`,
        params: {
          point_id,
        },
      }),
      providesTags: () => ['Ticket'],
    }),
    getTicket: build.query<IItem, any>({
      query: (ticket_id) => ({
        url: `/tickets/ticketByTicketId`,
        params: {
          ticket_id,
        },
      }),
      providesTags: () => ['Ticket', 'Warehouse'],
    }),
    createTicket: build.mutation<IItem, any>({
      query: (body) => ({
        url: `/tickets/createTicket`,
        method: 'POST',
        body: body,
      }),
      invalidatesTags: ['Ticket'],
    }),
    updateTicket: build.mutation<IItem, any>({
      query: (body) => ({
        url: `/ticket`,
        method: 'PATCH',
        body: body,
      }),
      invalidatesTags: ['Ticket', 'Warehouse'],
    }),
    getTicketServicesByTicketId: build.query<
      TServiceListResponse | undefined,
      string
    >({
      query: (ticketId) => ({
        url: `/ticket/${ticketId}/services`,
      }),
      providesTags: () => ['Services'],
    }),
    deleteTicket: build.mutation<any, any>({
      query: (id) => ({
        url: `/tickets/deleteTicket/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Ticket'],
    }),
  }),
});
